import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static draft(postId) {
        return PostApiBase.draft({
            post_id: postId,
        }).then((resp) => {
            return resp.data
        })
    }
}
